module.exports = __webpack_public_path__ + "static/media/37.8b12644a.jpeg";